var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortArrowsDesc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.707 16.057C23.3165 16.4476 22.6833 16.4476 22.2928 16.057L20.2999 14.0641L18.307 16.057C17.9165 16.4476 17.2833 16.4476 16.8928 16.057C16.5022 15.6665 16.5022 15.0333 16.8928 14.6428L19.5928 11.9428C19.9833 11.5523 20.6165 11.5523 21.007 11.9428L23.707 14.6428C24.0975 15.0333 24.0975 15.6665 23.707 16.057Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8929 23.5929C17.2834 23.2024 17.9166 23.2024 18.3071 23.5929L20.3 25.5858L22.2929 23.5929C22.6834 23.2024 23.3166 23.2024 23.7071 23.5929C24.0976 23.9834 24.0976 24.6166 23.7071 25.0071L21.0071 27.7071C20.6166 28.0976 19.9834 28.0976 19.5929 27.7071L16.8929 25.0071C16.5023 24.6166 16.5023 23.9834 16.8929 23.5929Z",
    fill: "#2897FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrowsDesc);
export default __webpack_public_path__ + "static/media/sort-arrows-desc.4cb0142db1488d7224163b2eea9d9e30.svg";
export { ForwardRef as ReactComponent };